<template>
  <div
    v-if="item && !item.IsNextSectionAvailable"
    :class="`shelf bom-count-${bomItemCount}`"
  >
    <div class="section-button" v-if="!item.isComplete">
      <button
        class="btn btn-primary"
        @click="saveAndContinue(item, 'finished')"
        :disabled="disableButton"
      >
        <span class="material-icons done-all-icon">
          done_all
        </span>
        I'm Finished
      </button>
      <p class="finished-message">
        Once you are finished, click the button to be able to add to your cart
        or quote.
      </p>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  props: {
    item: {
      isComplete: Boolean,
      sectionId: Number,
      sectionOptionValues: Array,
      selectedOptions: Array,
      IsNextSectionAvailable: Boolean
    },
    componentStateFinishClicked: {
      type: Boolean
    },
    // this needs to be referenced somewhere in the template so the component is rerendered when the bom is updated
    // removing this from the template will break it
    bomItemCount: {
      type: Number
    }
  },
  data() {
    return {
      disableButton: false
    };
  },
  mounted: function() {
    this.$root.$on("imFinishedEvent", valid => {
      this.disableButton = valid;
    });
  },
  beforeUpdate() {
    const bomLength = this.getBomSourceOfTruth.length;
    if (true === this.componentStateFinishClicked && bomLength > 0) {
      // this event posts accesories and updates the database in the parent component
      this.$emit("bom-updated");
    }
  },
  computed: {
    ...mapGetters("enhancedBom", ["getBomSourceOfTruth"])
  },
  methods: {
    // NOTE: any code changes also need to be reflected in the ProductOptionsItem component
    saveAndContinue(item, type) {
      // for the I'm Finished button
      if ("finished" === type) {
        // this sends an event to the parent container that finished was clicked
        // the parent component handles the logic and api calls are made in beforeUpdate lifecycle method after the store has been updated
        this.$emit("finish-clicked", item);
      }
      let updatedItem = JSON.parse(JSON.stringify(item));
      updatedItem.isComplete = true;

      this.$store.dispatch("enhancedproduct/saveAndContinue", item).then(() => {
        this.$store.dispatch(
          "enhancedproduct/updateSaveAndContinueItem",
          updatedItem
        );
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.button-style {
  width: 100%;
  height: 49px;
}
.shelf {
  margin-bottom: 10px;
}
.shelf_lg {
  margin-bottom: 25px;
}
.shelf_xl {
  margin-bottom: 35px;
}
.done-all-icon {
  margin: 0 10px 0 0;
}
.finished-message {
  color: rgb(102, 103, 102);
  font-family: $font-family-sans-serif-regular;
  font-size: 14px;
  letter-spacing: 0.25px;
  line-height: 18px;
  margin-top: 5px;
  text-align: left;
  font-weight: normal;
  text-transform: none;
}
.section-button > button {
  display: flex;
  width: 100%;
  align-items: center;
  justify-content: center;
  height: 49px;
  font-size: 16px;
  font-weight: bold;
  text-transform: uppercase;
  letter-spacing: 0.75px;
  line-height: 24px;
}
</style>
